import { define } from '../../define.js';
import { Select } from './select.js';
export * from './select.js';
define('select', Select);
